/**
 * Shipping Protection (product page).
 * If the opt-in checkbox is ticked when a product is added to the cart,
 * the hidden "shipping-protection" product is added right after (quantity always 1).
 * Works by watching the theme's own add-to-cart request, so it is independent of
 * the bundle / subscription options.
 */
(function () {
  if (window.__shippingProtectionInit) return;
  window.__shippingProtectionInit = true;

  var originalFetch = window.fetch.bind(window);

  function getBox() {
    return document.querySelector('.sp-box[data-sp-variant-id]');
  }

  function isProtectionWanted() {
    var box = getBox();
    var input = box && box.querySelector('.sp-box__input');
    return Boolean(input && input.checked);
  }

  function addProtection() {
    var box = getBox();
    if (!box) return Promise.resolve();
    var updates = {};
    updates[box.dataset.spVariantId] = 1;
    var root = (window.routes && window.routes.cart_update_url) || '/cart/update';
    return originalFetch(root + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates }),
    });
  }

  window.fetch = function (input, init) {
    var request = originalFetch(input, init);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || String(input);
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var isAddToCart = method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url);

      if (isAddToCart && isProtectionWanted()) {
        return request.then(function (response) {
          if (!response.ok) return response;
          return addProtection()
            .catch(function (e) {
              console.error(e);
            })
            .then(function () {
              return response;
            });
        });
      }
    } catch (e) {
      console.error(e);
    }
    return request;
  };
})();
